export default __webpack_public_path__ + "static/media/earth_small_1.b6f61fdc.svg";